import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "./Vendor.css";
import config from "../../config";
const { useAuth } = require('../../Auth/AuthContext');

const getVendorDataUrl = `${config.BASE_URL}/list-vendor`;
const insertVendorDataUrl = `${config.BASE_URL}/add-vendor`;
const updateVendorDataUrl = `${config.BASE_URL}/update-vendor`;
const deleteVendorDataUrl = `${config.BASE_URL}/delete-vendor`;
const Vendor = () => {
    const [result, setResult] = useState([]);
    const [error, setError] = useState(false);
    const [errorpan, setErrorPan] = useState(false);
    const [errorgst, setErrorGST] = useState(false);
    const [errorgstApplicable, setErrorGSTApplicable] = useState(false);
    const [errorEmail, setErrorEmail] = useState(false);
    const [errorMobile, setErrorMobile] = useState(false);
    const [errrBankName, setErrorBankName] = useState(false);
    const [errorBankAccount, setErrorBankAccount] = useState(false);
    const [errorIfscCode, setErrorIfscCode] = useState(false);
    const [deleteModal, setDeleteModal] = useState({
        isOpen: false,
        recordId: null,
    });

    const { userProfile, activeModule, setActiveModule } = useAuth();

    const [formData, setFormData] = useState({
        companyName: "",
        companyOwner: "",
        tdsRate: 0,
        pan: "",
        gst: "",
        gstApplicable: "", // Changed default to 'No' string instead of boolean
        email: "",
        mobile: "",
        bankName: "",
        bankAccount: "",
        ifscCode: "",
    });

    const [submitMessage, setSubmitMessage] = useState("");
    const [editingId, setEditingId] = useState(null); // Track which row is being edited
    const [editingData, setEditingData] = useState({}); // Store data of the row being edited
    const editRef = useRef(null);

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        sessionStorage.setItem('actMod', 'vendor');
        setActiveModule(sessionStorage.getItem('actMod'));
    }, []);

    const fetchData = async () => {
        try {
            setError(false);
            const response = await axios.get(getVendorDataUrl, {
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                },
            });
            if (response?.data && Array.isArray(response.data)) {
                console.log('Result Data:', response.data);
                setResult(response.data);
            } else {
                setResult([]);
            }
        } catch (error) {
            setError(true);
            console.error("Error while fetching vendors:", error);
        }
    };

    const capitalizeWords = (string) => {
        return string
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(" ");
    };

    const capitalizeGSTPANIFSC = (string) => {
        return string
            .split(" ")
            .map((word) => word.toUpperCase())
            .join(" ");
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        let inputValue = value.trim();

        const alphanumericRegex = /^[a-zA-Z0-9]*$/;

        if (name === "pan" || name === "gst" || name === "ifscCode") {
            if (!alphanumericRegex.test(inputValue)) return;
        }

        if (name === "gst" || name === "pan" || name === "ifscCode") {
            inputValue = capitalizeGSTPANIFSC(value);
        } else if (name === "companyName" || name === "companyOwner" || name === "bankName") {
            inputValue = capitalizeWords(value);
        }

        if (name === "mobile" || name === "bankAccount") {
            inputValue = inputValue ? Number(inputValue) : null;
        }

        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: inputValue,
        }));

        if (name === "pan" && inputValue.length === 10) {
            setErrorPan("");
        }
        if (name === "gst" && inputValue.length === 15) {
            setErrorGST("");
        }
        if (name === "email" && inputValue) {
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            setErrorEmail(!emailRegex.test(inputValue));
        }
        if (name === "mobile" && inputValue) {
            const mobileRegex = /^[0-9]{10}$/;
            setErrorMobile(!mobileRegex.test(inputValue.toString()));
        }
        if (name === "bankName" && inputValue) {
            const bankNameRegex = /^[a-zA-Z0-9\s]{1,40}$/;
            setErrorBankName(!bankNameRegex.test(inputValue));
        }
        if (name === "bankAccount" && inputValue) {
            const bankAccountRegex = /^[0-9]{9,18}$/;
            setErrorBankAccount(!bankAccountRegex.test(inputValue.toString()));
        }
        if (name === "ifscCode" && inputValue) {
            const ifscCodeRegex = /^[A-Z]{4}[0][A-Z0-9]{6}$/;
            setErrorIfscCode(!ifscCodeRegex.test(inputValue));
        }
        console.log(formData);
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        console.log("Form submitted:", formData);

        let isValid = true;
        let panError = "";
        let gstError = "";
        let emailError = "";
        let mobileError = "";
        let bankNameError = "";
        let bankAccountError = "";
        let ifscError = "";

        if (formData.pan.length !== 0 && formData.pan.length !== 10) {
            panError = "PAN must be either empty or exactly 10 characters!";
            isValid = false;
        }

        if (formData.gst.length !== 0 && formData.gst.length !== 15) {
            gstError = "GST must be either empty or exactly 15 characters!";
            isValid = false;
        }

        if (formData.email && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)) {
            emailError = "Invalid email address!";
            isValid = false;
        }

        if (formData.mobile && !/^[0-9]{10}$/.test(formData.mobile)) {
            mobileError = "Mobile number must be exactly 10 digits or empty!";
            isValid = false;
        }

        if (formData.bankName && !/^[a-zA-Z0-9\s]{1,40}$/.test(formData.bankName)) {
            bankNameError = "Bank name must be at most 40 characters or empty!";
            isValid = false;
        }

        if (formData.bankAccount && !/^[0-9]{9,18}$/.test(formData.bankAccount)) {
            bankAccountError = "Bank account number must be between 9 and 18 digits or empty!";
            isValid = false;
        }

        if (formData.ifscCode && !/^[A-Z]{4}[0][A-Z0-9]{6}$/.test(formData.ifscCode)) {
            ifscError = "Invalid IFSC code!";
            isValid = false;
        }

        setErrorPan(panError);
        setErrorGST(gstError);
        setErrorEmail(emailError);
        setErrorMobile(mobileError);
        setErrorBankName(bankNameError);
        setErrorBankAccount(bankAccountError);
        setErrorIfscCode(ifscError);

        if (!isValid) return;

        try {
            const response = await axios.post(insertVendorDataUrl, formData, {
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                },
            });
            console.log("response:::>>>>>", response.data);
            if (response.status === 200) {
                setSubmitMessage(response.data.message);
                fetchData();
            }
            setFormData({
                companyName: "",
                companyOwner: "",
                tdsRate: "",
                pan: "",
                gst: "",
                gstApplicable: "",
                email: "",
                mobile: "",
                bankName: "",
                bankAccount: "",
                ifscCode: "",
            });

            setErrorPan("");
            setErrorGST("");
            setErrorEmail("");
            setErrorMobile("");
            setErrorBankName("");
            setErrorBankAccount("");
            setErrorIfscCode("");

            setTimeout(() => {
                setSubmitMessage("");
            }, 3000);

        } catch (error) {
            if (error.response && error.response.status === 409) {
                setSubmitMessage(error.response.data.message || "Duplicate vendor entry detected.");
            } else {
                setSubmitMessage("Failed to submit vendor. Please try again.");
            }
        }
    };

    const handleEdit = (vendor) => {
        setEditingId(vendor.id);
        setEditingData(vendor);
    };

    const handleEditInputChange = (e) => {
        const { name, value } = e.target;

        let inputValue = value.trim();

        const alphanumericRegex = /^[a-zA-Z0-9]*$/;

        if (name === "pan" || name === "gst" || name === "ifscCode") {
            if (!alphanumericRegex.test(inputValue)) return;
        }

        if (name === "gst" || name === "pan" || name === "ifscCode") {
            inputValue = capitalizeGSTPANIFSC(value);
        } else if (name === "companyName" || name === "companyOwner" || name === "bankName") {
            inputValue = capitalizeWords(value);
        }

        if (name === "mobile" || name === "bankAccount") {
            const numericValue = value.replace(/\D/g, ""); // Remove non-numeric characters

            setEditingData((prevData) => ({
                ...prevData,
                [name]: numericValue, // Store only numbers
            }));

            return;
        }

        setEditingData((prevData) => ({
            ...prevData,
            [name]: inputValue,
        }));

        if (name === "pan" && inputValue.length === 10) {
            setErrorPan("");
        }
        if (name === "gst" && inputValue.length === 15) {
            setErrorGST("");
        }
        if (name === "email" && inputValue) {
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            setErrorEmail(!emailRegex.test(inputValue));
        }
        if (name === "mobile" && inputValue) {
            const mobileRegex = /^[0-9]{10}$/;
            setErrorMobile(!mobileRegex.test(inputValue.toString()));
        }
        if (name === "bankName" && inputValue) {
            const bankNameRegex = /^[a-zA-Z0-9\s]{1,40}$/;
            setErrorBankName(!bankNameRegex.test(inputValue));
        }
        if (name === "bankAccount" && inputValue) {
            const bankAccountRegex = /^[0-9]{9,18}$/;
            setErrorBankAccount(!bankAccountRegex.test(inputValue.toString()));
        }
        if (name === "ifscCode" && inputValue) {
            const ifscCodeRegex = /^[A-Z]{4}[0][A-Z0-9]{6}$/;
            setErrorIfscCode(!ifscCodeRegex.test(inputValue));
        }

        console.log("editingData", editingData);
    };

    const handleSave = async () => {
        try {
            const response = await axios.post(updateVendorDataUrl, editingData, {
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                },
            });
            if (response.status === 200) {
                console.log("Edit response:", response.data);
                alert(response.data.message)
                fetchData(); // Refresh the data
            }
            setEditingId(null); // Reset edit mode
            setEditingData({}); // Clear editing data
        } catch (error) {
            if (error.response && error.response.status === 409) {
                alert(error.response.data.message || "Duplicate vendor entry detected.");
            } else {
                alert("Failed to submit vendor. Please try again.");
            }
            setEditingId(null); // Reset edit mode
            setEditingData({}); // Clear editing data
        }
    };

    const handleDelete = async (id) => {
        const deleteVendor = result.find((vendor) => vendor.id === id);
        console.log("Delete button clicked for ID:", id);
        setDeleteModal({
            isOpen: true,
            recordId: id,
            companyName: deleteVendor?.companyName || "",
        });
    }

    const confirmDelete = async () => {
        try {
            const response = await axios.delete(`${deleteVendorDataUrl}/${deleteModal.recordId}`, {
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                }
            });
            // setResult((prev) => prev.filter((item) => item._id !== deleteModal.recordId));
            if (response.status === 200) {
                console.log("Vendor deleted successfully:", deleteModal.recordId);
                alert("Vendor deleted successfully!");
                fetchData(); // Refresh the data
            } else {
                alert("Failed to delete Vendor.");
            }
            setDeleteModal({ isOpen: false, recordId: null });
            // Show success notification (you could add a toast notification system here)
        } catch (error) {
            console.error('Error deleting record:', error);

            let errorMessage = 'Error deleting record';
            if (error.response?.data?.message) {
                errorMessage = error.response.data.message;
            } else if (error.message) {
                errorMessage = error.message;
            }
            setDeleteModal({ isOpen: false, recordId: null });
            alert(errorMessage);
        }
    };


    useEffect(() => {
        const handleClickOutside = (event) => {
            const tableContainer = document.querySelector('.table-wrapper');
            const scrollBarThreshold = 15; // Threshold to consider as the scrollbar area (adjust as needed)

            // Check if the click is inside the table or not
            if (editRef.current && !editRef.current.contains(event.target) && !tableContainer.contains(event.target)) {
                // Check if the event target is near the scrollbar area (either vertical or horizontal)
                const isHorizontalScrollbar = event.clientY > window.innerHeight - scrollBarThreshold;
                const isVerticalScrollbar = event.clientX > window.innerWidth - scrollBarThreshold;

                if (isHorizontalScrollbar || isVerticalScrollbar) {
                    return; // Ignore the scrollbar area
                }

                console.log("Clicked outside the table, resetting edit mode.");
                setEditingId(null);
                setEditingData({});
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div id="vendor">
            <div className="container-vendor">
                <form autoComplete="off" className="vendorForm" onSubmit={handleFormSubmit}>
                    <div className="filterItem">
                        <label htmlFor="companyName">Vendor Name:</label>
                        <input
                            type="text"
                            id="companyName"
                            name="companyName"
                            value={formData.companyName}
                            onChange={handleInputChange}
                            required
                        />
                        <p className="hint">Vendor Name should be 3-40 characters long.</p>
                    </div>

                    <div className="filterItem">
                        <label htmlFor="companyOwner">Vendor Owner:</label>
                        <input
                            type="text"
                            id="companyOwner"
                            name="companyOwner"
                            value={formData.companyOwner}
                            onChange={handleInputChange}
                            required
                        />
                        <p className="hint">Vendor Owner should be 3-40 characters long.</p>
                    </div>

                    <div className="filterItem">
                        <label htmlFor="tdsRate">TDS Rate (%):</label>
                        <input
                            type="number"
                            id="tdsRate"
                            name="tdsRate"
                            step="0.01"
                            value={formData.tdsRate}
                            onChange={handleInputChange}
                        />
                        <p className="hint">TDS Rate should be a number between 0 and 100.</p>
                    </div>

                    <div className="filterItem">
                        <label htmlFor="pan">PAN:</label>
                        <input
                            type="text"
                            id="pan"
                            name="pan"
                            value={formData.pan}
                            onChange={handleInputChange}
                        />
                        {errorpan && <p style={{ color: "red" }}>{errorpan}</p>}
                        <p className="hint">PAN should be exactly 10 alphanumeric characters.</p>
                    </div>

                    <div className="filterItem">
                        <label htmlFor="gst">GST:</label>
                        <input
                            type="text"
                            id="gst"
                            name="gst"
                            value={formData.gst}
                            onChange={handleInputChange}
                        />
                        {errorgst && <p style={{ color: "red" }}>{errorgst}</p>}
                        <p className="hint">GST should be exactly 15 alphanumeric characters.</p>
                    </div>

                    <div className="filterItem">
                        <label htmlFor="gstApplicable">GST Applicable:</label>
                        <select
                            id="gstApplicable"
                            name="gstApplicable"
                            value={formData.gstApplicable}
                            onChange={handleInputChange}
                        >
                            <option value="">Select</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                        {errorgstApplicable && <p style={{ color: "red" }}>{errorgstApplicable}</p>}
                        <p className="hint">Select whether GST is applicable for this vendor.</p>
                    </div>

                    <div className="filterItem">
                        <label htmlFor="email">Email:</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                        />
                        {errorEmail && <p style={{ color: "red" }}>{errorEmail}</p>}
                        <p className="hint">Email should be in the format: example@domain.com</p>
                    </div>

                    <div className="filterItem">
                        <label htmlFor="mobile">Mobile:</label>
                        <input
                            type="number"
                            id="mobile"
                            name="mobile"
                            value={formData.mobile}
                            onChange={handleInputChange}
                        />
                        {errorMobile && <p style={{ color: "red" }}>Mobile number must be exactly 10 digits or empty!</p>}
                        <p className="hint">Mobile should be exactly 10 digits.</p>
                    </div>

                    <div className="filterItem">
                        <label htmlFor="bankName">Bank Name:</label>
                        <input
                            type="text"
                            id="bankName"
                            name="bankName"
                            value={formData.bankName}
                            onChange={handleInputChange}
                        />
                        {errrBankName && <p style={{ color: "red" }}>Bank name must be at most 40 characters or empty!</p>}
                        <p className="hint">Bank Name should be 1-40 characters long.</p>
                    </div>

                    <div className="filterItem">
                        <label htmlFor="bankAccount">Bank Account Number:</label>
                        <input
                            type="number"
                            id="bankAccount"
                            name="bankAccount"
                            value={formData.bankAccount}
                            onChange={handleInputChange}
                        />
                        {errorBankAccount && <p style={{ color: "red" }}>Bank account number must be between 9 and 18 digits or empty!</p>}
                        <p className="hint">Enter a 9-18 digit bank account number.</p>
                    </div>

                    <div className="filterItem">
                        <label htmlFor="ifscCode">IFSC Code:</label>
                        <input
                            type="text"
                            id="ifscCode"
                            name="ifscCode"
                            value={formData.ifscCode}
                            onChange={handleInputChange}
                        />
                        {errorIfscCode && <p style={{ color: "red" }}>Invalid IFSC code!</p>}
                        <p className="hint">IFSC Code should be in the format: ABCD0123456.</p>
                    </div>

                    <button className="submit-button" type="submit">
                        Submit
                    </button>
                    <p>{submitMessage}</p>
                </form>

                <div className="table-wrapper" id="results">
                    <table id="resultsTable">
                        <thead>
                            <tr>
                                <th>Index</th>
                                <th>Vendor Name</th>
                                <th>Vendor Owner</th>
                                <th>TDS Rate (%)</th>
                                <th>GST</th>
                                <th>GST Applicable</th>
                                <th>PAN</th>
                                <th>Email</th>
                                <th>Mobile</th>
                                <th>Bank Name</th>
                                <th>Bank Account Number</th>
                                <th>IFSC Code</th>
                                <th>Edit</th>
                                <th>Delete</th>
                            </tr>
                        </thead>
                        <tbody>
                            {error ? (
                                <tr>
                                    <td colSpan="14">Error fetching data. Please try again later.</td>
                                </tr>
                            ) : result.length === 0 ? (
                                <tr>
                                    <td colSpan="14" className="empty-row">
                                        No data available.
                                    </td>
                                </tr>
                            ) : (
                                result.map((vendor) => (
                                    <tr
                                        key={vendor.id}
                                        ref={editingId === (vendor.id) ? editRef : null}
                                    >
                                        <td>{vendor.index}</td>
                                        <td>
                                            {editingId === (vendor.id) ? (
                                                <input
                                                    type="text"
                                                    name="companyName"
                                                    value={editingData.companyName}
                                                    onChange={handleEditInputChange}
                                                />
                                            ) : (
                                                vendor.companyName
                                            )}
                                        </td>
                                        <td>
                                            {editingId === (vendor.id) ? (
                                                <input
                                                    type="text"
                                                    name="companyOwner"
                                                    value={editingData.companyOwner}
                                                    onChange={handleEditInputChange}
                                                />
                                            ) : (
                                                vendor.companyOwner
                                            )}
                                        </td>
                                        <td>
                                            {editingId === (vendor.id) ? (
                                                <input
                                                    type="number"
                                                    name="tdsRate"
                                                    value={editingData.tdsRate}
                                                    onChange={handleEditInputChange}
                                                />
                                            ) : (
                                                vendor.tdsRate || 0
                                            )}
                                        </td>
                                        <td>
                                            {editingId === (vendor.id) ? (
                                                <input
                                                    type="text"
                                                    name="gst"
                                                    value={editingData.gst}
                                                    onChange={handleEditInputChange}
                                                />
                                            ) : (
                                                vendor.gst
                                            )}
                                        </td>
                                        <td>
                                            {editingId === (vendor.id) ? (
                                                <select
                                                    name="gstApplicable"
                                                    value={editingData.gstApplicable}
                                                    onChange={handleEditInputChange}
                                                >
                                                    <option value="">Select</option>
                                                    <option value="Yes">Yes</option>
                                                    <option value="No">No</option>
                                                </select>
                                            ) : (
                                                vendor.gstApplicable
                                            )}
                                        </td>
                                        <td>
                                            {editingId === (vendor.id) ? (
                                                <input
                                                    type="text"
                                                    name="pan"
                                                    value={editingData.pan}
                                                    onChange={handleEditInputChange}
                                                />
                                            ) : (
                                                vendor.pan
                                            )}
                                        </td>
                                        <td>
                                            {editingId === (vendor.id) ? (
                                                <input
                                                    type="email"
                                                    name="email"
                                                    value={editingData.email}
                                                    onChange={handleEditInputChange}
                                                />
                                            ) : (
                                                vendor.email
                                            )}
                                        </td>
                                        <td>
                                            {editingId === (vendor.id) ? (
                                                <input
                                                    type="text"
                                                    name="mobile"
                                                    value={editingData.mobile}
                                                    onChange={handleEditInputChange}
                                                />
                                            ) : (
                                                vendor.mobile
                                            )}
                                        </td>

                                        <td>
                                            {editingId === (vendor.id) ? (
                                                <input
                                                    type="text"
                                                    name="bankName"
                                                    value={editingData.bankName}
                                                    onChange={handleEditInputChange}
                                                />
                                            ) : (
                                                vendor.bankName
                                            )}
                                        </td>

                                        <td>
                                            {editingId === (vendor.id) ? (
                                                <input
                                                    type="text"
                                                    name="bankAccount"
                                                    value={editingData.bankAccount}
                                                    onChange={handleEditInputChange}
                                                />
                                            ) : (
                                                vendor.bankAccount
                                            )}
                                        </td>

                                        <td>
                                            {editingId === (vendor.id) ? (
                                                <input
                                                    type="text"
                                                    name="ifscCode"
                                                    value={editingData.ifscCode}
                                                    onChange={handleEditInputChange}
                                                />
                                            ) : (
                                                vendor.ifscCode
                                            )}
                                        </td>

                                        <td>
                                            {editingId === (vendor.id) ? (
                                                <button
                                                    className="save-btn"
                                                    onClick={handleSave}
                                                >
                                                    Save
                                                </button>
                                            ) : (
                                                <button
                                                    className="edit-btn"
                                                    onClick={() => handleEdit(vendor)}
                                                >
                                                    Edit
                                                </button>
                                            )}
                                        </td>
                                        {/* {
                                            (userProfile !== 'loadingManager' && userProfile !== 'unloadingManager')
                                            && */}
                                        <td>
                                            <button
                                                className="delete-btn"
                                                onClick={() => handleDelete(vendor.id)} // Open the modal with the ID
                                            >
                                                Delete
                                            </button>
                                        </td>
                                        {/* } */}
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                    {deleteModal.isOpen && (
                        <div className="delete-modal-overlay">
                            <div className="delete-modal">
                                <div className="delete-modal-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="54" height="54">
                                        <path fill="none" d="M0 0h24v24H0z" />
                                        <path fill="#ff4757" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-11.414L9.172 7.757 7.757 9.172 10.586 12l-2.829 2.828 1.415 1.415L12 13.414l2.828 2.829 1.415-1.415L13.414 12l2.829-2.828-1.415-1.415L12 10.586z" />
                                    </svg>
                                </div>
                                <h3>Confirm Delete</h3>
                                <p>Are you sure you want to delete this Vendor:
                                    <span className="trip-id-highlight"> {deleteModal.companyName}</span>?</p>
                                <p className="warning-text">This action cannot be undone.</p>
                                <div className="delete-modal-buttons">
                                    <button className="cancel-btn" onClick={() => setDeleteModal({ isOpen: false, recordId: null })}>
                                        Cancel
                                    </button>
                                    <button className="confirm-delete-btn" onClick={confirmDelete}>
                                        Delete
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Vendor;